import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { DontTreeShakeModuleAndComponents } from '@epicuro-next/elements/core';
import { ProductCardModule } from '@epicuro-next/product-card';

import { PcardsComponent } from './components/pcards/pcards.component';
import { PCardsService } from './service/pcards-service';

// tslint:disable-next-line:no-any
const components: any[] | Type<any[]> = [PcardsComponent];

@NgModule({
  imports: [CommonModule, ProductCardModule, ...components],
  providers: [PCardsService],
})
export class ContentBusinessComponentsModule {}

// This has a tech debt and needs to be fixed
DontTreeShakeModuleAndComponents(
  ContentBusinessComponentsModule,
  'ContentBusinessComponentsModule',
  components,
);
